import axios from 'axios';

let baseURL = 'https://id-backend-ttpbdh5h7a-uc.a.run.app/api/auth';

const id_auth_axios = axios.create({
  baseURL,
});

export { id_auth_axios };
